module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": _vm.adding ? 'primary' : 'success',
      "heading": _vm.heading,
      "size": "medium",
      "button-icon": "fa fa-home",
      "centerButton": true,
      "buttonText": _vm.button,
      "disableButton": !_vm.isManager('property|finance') || _vm.readOnly
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('update-tenancy', {
    ref: "updateTenancy",
    attrs: {
      "site-data": _vm.siteData,
      "tenancy-data": _vm.tData,
      "contact-data": _vm.cData,
      "adding": _vm.adding,
      "read-only": _vm.readOnly
    },
    on: {
      "update": _vm.fireUpdate
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-518878cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/TenancyAction.vue
// module id = 1562
// module chunks = 0